import axios from 'axios'
import { alert } from "devextreme/ui/dialog"
const baseUri = "WebApi.asmx/api/genericListService";
const store = {};
const mutations = {
    GET_EVALUATION_LIST(state, data) {
        if (data.success) {
            data.data.forEach(m => {
                m.Experts = m.RatTxt ? m.RatTxt.replace(/(?:\r\n|\r|\n)/g, '<br/>') : "";
            });
            state.evaluationList = data.data;
            state.evaluationListLoading = false;
            state.ratingFields = data.ratingFields;
            window.LoadPanel.Hide();
        }
    },
    GET_EXPERTS_LIST(state, data) {
        if (data.success) {
            state.expertsList = data.expertList;
        }
    },
    SEND_BULK_MAIL(state, data) {
        if (data.success) {
            state.mailingLoaing = false;
        }
    },
};
const state = {
    evaluationList: [],
    evaluationListLoading: false,
    mailingLoaing: false,
    ratingFields: [],
    expertsList: []
};
const getters = {};
const actions = {
    sendBulkMail({ commit }, args) {

        window.LoadPanel.Show();
        state.mailingLoaing = true;
        var formData = new FormData();
        formData.append("args", args);

        return axios
            .post(baseUri + '/BulkSendSimpleMail', formData)
            .then(res => {
                window.LoadPanel.Hide();
                if (res.data.success == true) {
                    commit('SEND_BULK_MAIL', res.data);
                    return res.data;
                }
                else {
                    alert(res.data.errorMessage, "Send Bulk Mail");
                    return res.data;
                }
            });

    },
    getEvaluationList({ commit }, args) {
        window.LoadPanel.Show();
        state.evaluationListLoading = true;
        if (args.rtgId > 0) {
            return  axios
                .get(baseUri + '/GetEvaluationList?RtgId=' + args.rtgId)
                .then(res => {
                    if (res.data.success == true) {
                        commit('GET_EVALUATION_LIST', res.data);
                    }
                    else {
                        alert(res.data.errorMessage, "Evaluation Overview");
                    }
                    return res;
                });
        }
        else {
            commit('GET_EVALUATION_LIST', { success: true, data: [], ratingFields: [] });
        }
    },
    getExpertsList({ commit }, args) {
        return axios
            .get(baseUri + '/GetExpertsList?RtgId=' + args.rtgId)
            .then(res => {
                if (res.data.success == true) {
                    commit('GET_EXPERTS_LIST', res.data);
                }
                else {
                    alert(res.data.errorMessage, "Bulk Experts Assignement");
                }
                return res;
            });
    },


};


export default {
    state,
    store,
    mutations,
    getters,
    actions
}